export const Spinner = () => (
  <div className='flex flex-col items-center justify-center space-y-2 py-4'>
    <div className='relative h-10 w-10'>
      <div
        className='absolute inset-0 animate-spin rounded-full bg-gradient-to-tr from-blue-300 via-blue-500 to-blue-700'
        style={{
          maskImage: 'radial-gradient(farthest-side, transparent 80%, black 81%)',
          WebkitMaskImage: 'radial-gradient(farthest-side, transparent 80%, black 81%)',
        }}
      />
      <div className='absolute inset-2 rounded-full bg-white' />
    </div>
    <span className='text-sm'>Loading, please wait...</span>
  </div>
);
